module.exports = __webpack_public_path__ + "img/JPC.3b014ab9.png";